import dateUtils from '@utils/DateUtils'

export class TaskStatus {
  constructor (code) {
    this._code = code
    this.mapData(code)
  }
  mapData (code) {
    switch (code) {
      case 100:
        this._color = '#44C87C'
        this._text = 'Success'
        break
      case 5:
        this._color = '#1726ca'
        this._text = 'Created'
        break
      case 7:
        this._color = '#c57000'
        this._text = 'Pending'
        break
      case 10:
        this._color = 'teal'
        this._text = 'Processing'
        break
      case -50:
        this._color = '#E65100'
        this._text = 'Holding'
        break
      case -100:
        this._color = '#EB5757'
        this._text = 'Error'
        break
      case -200:
        this._color = '#F2C94C'
        this._text = 'Canceled'
        break
      default:
        this._color = ''
        this._text = 'Undefined'
        break
    }
  }
  get code () {
    return this._code
  }
  set code (val) {
    this._code = val
  }

  get isProcessing () {
    return this._code >= 10 && this._code < 100
  }

  get isCreated () {
    return this._code === 5
  }

  get isCanceled () {
    return this._code === -200
  }

  get isSuccess () {
    return this._code === 100
  }

  get isHolding () {
    return this._code === -50
  }

  get isError () {
    return this._code < 0 && this._code !== -200
  }

  get text () {
    return this._text
  }

  set text (val) {
    this._text = val
  }

  get color () {
    return this._color
  }

  set color (val) {
    this._color = val
  }
}
export default class Task {
  constructor (task) {
    this._isResubmit = task.is_resubmit
    this._id = task.id
    this._percent = 0
    this._inQueue = task.data ? task.data.position_in_queue : ''
    this._createdAt = task.created_at
    this._updatedAt = task.updated_at
    this._startTime = task.start_time
    this._endTime = task.end_time
    this._name = task.name
    this._data = task.data
    this._type = task.type
    this._cancelable = task.cancelable
    this._status = new TaskStatus(task.status)
    this._resultType = task.result_type ? task.result_type : undefined
    this._resultIds = task.result_ids ? task.result_ids : undefined
    this._loading = false
    this._loadingCancel = false
    this._expired = task.expired
    this._downloadUrl = task.download_url
    this._createdBy = task.owner ? task.owner.name : undefined
    this._tokenCost = task.token_cost
  }

  get isResubmit () {
    return this._isResubmit
  }

  get downloadUrl () {
    return this._downloadUrl
  }

  get loading () {
    return this._loading
  }

  get expired () {
    return this._expired
  }

  get inQueue () {
    return this._inQueue
  }

  set inQueue (newValue) {
    this._inQueue = newValue
  }

  set loading (newValue) {
    this._loading = newValue
  }

  get loadingCancel () {
    return this._loadingCancel
  }

  set loadingCancel (newValue) {
    this._loadingCancel = newValue
  }

  get resultType () {
    return this._resultType
  }

  get resultIds () {
    return this._resultIds
  }

  get id () {
    return this._id
  }

  get startTime () {
    if (this._startTime) {
      return dateUtils.convertUTCToLocalDateTime(this._startTime)
    }
    return ''
  }

  get endTime () {
    if (this._endTime) {
      return dateUtils.convertUTCToLocalDateTime(this._endTime)
    }
    return ''
  }

  get cancelable () {
    return this._cancelable
  }

  set id (val) {
    this._type = val
  }

  get createdAt () {
    return dateUtils.convertUTCToLocalDateTime(this._createdAt)
  }

  get updatedAt () {
    return dateUtils.convertUTCToLocalDateTime(this._updatedAt)
  }

  get type () {
    return this._type
  }

  get typeText () {
    return this._type ? this._type.replaceAll('_', ' ') : ''
  }

  set type (val) {
    this._type = val
  }

  get data () {
    return this._data
  }

  set data (val) {
    this._data = val
  }

  get icon() {
    const type = this._type ? this._type.toLowerCase() : ''
    switch (type) {

      case 'tree_counting':
      case 'agriculture_classifier':
      case 'predict_uav':
      case 'train_model':
        return 'mdi-robot' // biểu tượng AI/ML
      case 'mosaic':
      case 'clip_image':
      case 'ndvi':
      case 'create_bingmap':
      case 'create_sentinel1':
      case 'create_sentinel2':
      case 'upload_image':
        return 'mdi-satellite' // biểu tượng vệ tinh quang học
      case 'upload_vector':
        return 'mdi-vector-polygon'
      default:
        return 'mdi-check-decagram' // 
    }
  }

  get isImageProcessing () {
    switch (this._type.toLowerCase()) {
      case 'clip_image':
      case 'ndvi':
      case 'create_bing':
      case 'convert_uint8':
      case 'down scale':
      case 'remove cloud image':
      case 'px_based_change_detection':
      case 'align image':
      case 'clip':
      case 'haze removal':
      case 'cloud shadow removal':
      case 'upload_imagery':
      case 'create_sentinel1':
      case 'mosaic':
      case 'new image':
      case 'raster to image':
      case 'rgb render':
      case 'slope toolkit':
      case 'stack':
      case 'upload imagery':
      case 'upscale toolkit':
      case 'spatial adjustment image':
      case 'machine learning down scale':
      case 'crop toolkit':
      case 'create_xyz':
      case 'copy_image_to_workspace':
      case 'copy_shared_image':
      case 'copy_shared_folder':
      case 'create_sentinel2': return true
      default: return false
    }
  }
  get isPrepare () {
    switch (this._type.toLowerCase()) {
      case 'prepare_mosaic' : return true
      default: return false
    }
  }

  get name () {
    return this._name || this._type.replaceAll('_', ' ')
  }

  set name (val) {
    this._name = val
  }

  get status () {
    return this._status
  }

  set status (val) {
    this._status = val
  }

  get percent () {
    return this._percent || 0
  }

  set percent (val) {
    this._percent = val
  }

  get createdBy () {
    return this._createdBy
  }

  get tokenCost () {
    return this._tokenCost
  }
}



// WEBPACK FOOTER //
// ./src/models/task/task.js